<template>
  <div class="dashboard-page">
    <div v-if="roleKind === 'super'">
      <SuperHome />
    </div>
    <div v-else-if="roleKind === 'null'">
      <NoneRoleHome />
    </div>
    <div v-else>
      <ApplicationHome />
    </div>
  </div>
</template>

<script>
  import { Vue, Component } from 'vue-property-decorator';
  import SuperHome from './super_home';
  import ApplicationHome from './application_home';
  import NoneRoleHome from './none_role_home';
  import _ from 'lodash';

  @Component({
    components: {
      SuperHome,
      ApplicationHome,
      NoneRoleHome
    }
  })
  export default class Home extends Vue {
    get roleKind() {
      return _.get(this.$root.user, 'current_role.role.kind');
    }
  }
</script>

<style lang="scss">
  .dashboard-page {
    margin: 15px;

    .el-row {
      margin-bottom: 20px;
    }

    .el-card {
      .el-card__header {
        padding: 10px;
        font-size: 14px;
        color: #fff;
        background: $primary;
        text-align: center;
        font-weight: bold;
      }

      .statistics {
        height: 40px;
        text-align: center;
        font-size: 14px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
      }
    }
  }
</style>
